import Axios, { AxiosInstance } from 'axios';
import EndpointFactory from 'axios-endpoints';

import useInterceptors from '../interceptor';
import rewardsInterceptor from '../interceptor/interceptors/rewards';

const API: AxiosInstance = useInterceptors(Axios.create(), [
  rewardsInterceptor,
]);

const Endpoint = EndpointFactory(API);

export const rewardsGoalEndpoint = new Endpoint<{ userId?: number }>(({ userId }) => `/goal-user-point-summaries/user/${userId}`);
